import Combine from "../../components/Combine/Combine";
import QuranBook from "./QuranBook";

const Quran = () => {
  return (
    <Combine>
      <QuranBook />
    </Combine>
  );
};

export default Quran;
